import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BroadCastServiceService {

  token: string;
  subject = new Subject<any>();
  clientSubject = new Subject<any>();
  clientUnassignSubject = new Subject<any>();
  evaluationFeedbackSubject = new Subject<any>();
  accountantSubject = new Subject<any>();
  childSubject = new Subject<any>();
  specialitySubject = new Subject<any>();
  titleSubject = new Subject<any>();
  employeeFeedSub = new Subject<any>();
  employeeEvalSub = new Subject<any>();
  titleFeedSubject =  new Subject<any>();
  myAppointmentSub = new Subject<any>();
  submitFeedBackRequest = new Subject<any>();
  emailScheduledSubject = new Subject<any>();
  private broadcastSource = new Subject<boolean>();
  broadcast$ = this.broadcastSource.asObservable();
  custFeedDataSub = new Subject<any>();
  toggleFeedbackSub = new Subject<any>();
  constructor(private router: Router) { }

  childDataChanges(value:any){
    this.childSubject.next(value);
}

submitFeedbackRequestDaChanges(value:any){
  this.submitFeedBackRequest.next(value);
}

specialityDataChanges(value:any){
  this.specialitySubject.next(value);
}

titleDataChanges(value : any){
  this.titleSubject.next(value)
}

myAppDataChanges(value: any) {
  this.myAppointmentSub.next(value);
}

employeeFeedDropChanges(value: any) {
  this.employeeFeedSub.next(value)
}
employeeEvalFeedFilterChanges(value : any){
  this.employeeEvalSub.next(value);
}

titleDropChanges(value : any){
  this.titleFeedSubject.next(value)
}

filterCustomerFeedbackData(value : any){
  this.custFeedDataSub.next(value)
}

filterToggleFeedbackData(value : any){
  this.toggleFeedbackSub.next(value)
}
  sendMessage(data) {
      this.subject.next(data);
  }

  sendClientId(clientId: any) {
    this.clientSubject.next(clientId)
  }

  sendUnassigedClient(value: any) {
    this.clientUnassignSubject.next(value)
  }
  emailScheduled(value: boolean) {
    this.emailScheduledSubject.next(value)
  }

  sendEvaluationFeedbackMessage(value : any){
    this.evaluationFeedbackSubject.next(value)
  }

  sendAccId(accId : any){
    this.accountantSubject.next(accId)
  }

  clearMessage() {
      this.subject.next();
  }

  getMessage(): Observable<any> {
      return this.subject.asObservable();
  }

  getClientId(): Observable<any>{
      return this.clientSubject.asObservable();
  }

  getClientUnassigned(): Observable<any>{
    return this.clientUnassignSubject.asObservable();
}

  getEvaluationFeedback():Observable<any>{
  return this.evaluationFeedbackSubject.asObservable();
  }

getScheduledEmail(): Observable<any>{
  return this.emailScheduledSubject.asObservable();
}
  getAccId(): Observable<any>{
    return this.accountantSubject.asObservable();
  }


  getCriteriaMessage(): Observable<any> {
    return this.childSubject.asObservable();
}

getSubFeedReq(): Observable<any>  {
  return this.submitFeedBackRequest.asObservable();
}

getAppointmentMessage() : Observable<any> {
  return this.myAppointmentSub.asObservable();
}

getSpecialityMessage() : Observable<any> {
  return this.specialitySubject.asObservable();
}

getTitleMessage() : Observable<any> {
  return this.titleSubject.asObservable();
}

getEmployeeFeedMessage(): Observable<any> {
  return this.employeeFeedSub.asObservable();
}

getEvalEmployeeFeedMessage(): Observable<any> {
  return this.employeeEvalSub.asObservable();
}

getTitleFeedMessage(): Observable<any> {
  return this.titleFeedSubject.asObservable();
}

getCustFilterFeedMessage(): Observable<any> {
  return this.custFeedDataSub.asObservable();
}

getToggleFeedMessage(): Observable<any> {
  return this.toggleFeedbackSub.asObservable();
}

  generateObject() {
for(let index=0;index < 5; index++){
  this.sendMessage({name:'ranjan', age:25});
}
  }

  broadcastMessage(isBooleanValue: boolean) {
    this.broadcastSource.next(isBooleanValue);
  }
    
}
